import $ from 'jquery';
import QuotationForm from './forms/quotationForm';

$(() => {
  QuotationForm.bindQuotationForm();
});
